import { gql } from '@apollo/client'
import { UserProfileInfoFragment } from '../queries/userProfile.queries'

export const UpdateUserProfile = gql`
    mutation UpdateUserProfile(
        $updateUserProfile: UpdateUserProfileDataInput!
    ) {
        updateUserProfile(input: $updateUserProfile) {
            ...userProfileInfoFragment
        }
    }
    ${UserProfileInfoFragment}
`
